(function() {
  'use strict';

  // Bail early if server-side Liquid already rendered the blocked page.
  // NOTE: For Liquid layer to auto-detect CN via IP, the store must have
  // Shopify Markets → Geolocation enabled in the admin. Without it,
  // localization.country.iso_code reflects the user's *selected* market,
  // not their IP-based country.
  if (document.documentElement.hasAttribute('data-region-blocked')) return;

  /**
   * Render a full-screen "Access Denied / 访问被拒绝" page.
   */
  function renderBlockedPage() {
    var html =
      '<!doctype html>' +
      '<html lang="zh-CN">' +
      '<head>' +
        '<meta charset="utf-8">' +
        '<meta name="viewport" content="width=device-width, initial-scale=1">' +
        '<title>Access Denied · 访问被拒绝</title>' +
        '<style>' +
          '* { margin: 0; padding: 0; box-sizing: border-box; }' +
          'html, body { height: 100%; width: 100%; }' +
          'body {' +
            'display: flex;' +
            'justify-content: center;' +
            'align-items: center;' +
            'flex-direction: column;' +
            'min-height: 100vh;' +
            'background: #ffffff;' +
            'font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;' +
            'color: #1a1a1a;' +
            'text-align: center;' +
            'padding: 40px 24px;' +
          '}' +
          '.prohibition-icon {' +
            'width: 120px;' +
            'height: 120px;' +
            'margin-bottom: 32px;' +
            'animation: ppt-pulse 2.4s ease-in-out infinite;' +
          '}' +
          '@keyframes ppt-pulse {' +
            '0%, 100% { transform: scale(1); opacity: 1; }' +
            '50% { transform: scale(1.04); opacity: 0.9; }' +
          '}' +
          '.ppt-title {' +
            'font-size: clamp(28px, 5vw, 44px);' +
            'font-weight: 700;' +
            'letter-spacing: -0.02em;' +
            'margin-bottom: 16px;' +
            'color: #111111;' +
          '}' +
          '.ppt-subtitle {' +
            'font-size: clamp(16px, 2.2vw, 20px);' +
            'font-weight: 600;' +
            'color: #d32f2f;' +
            'margin-bottom: 24px;' +
          '}' +
          '.ppt-message {' +
            'font-size: clamp(14px, 1.8vw, 16px);' +
            'line-height: 1.7;' +
            'color: #555555;' +
            'max-width: 520px;' +
          '}' +
          '.ppt-divider {' +
            'width: 40px;' +
            'height: 2px;' +
            'background: #e0e0e0;' +
            'margin: 28px 0;' +
            'border-radius: 1px;' +
          '}' +
        '</style>' +
      '</head>' +
      '<body>' +
        '<svg class="prohibition-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<circle cx="12" cy="12" r="10" stroke="#d32f2f" stroke-width="2" fill="none"/>' +
          '<line x1="4.93" y1="4.93" x2="19.07" y2="19.07" stroke="#d32f2f" stroke-width="2.5" stroke-linecap="round"/>' +
        '</svg>' +
        '<h1 class="ppt-title">Access Denied</h1>' +
        '<div class="ppt-subtitle">访问被拒绝</div>' +
        '<div class="ppt-divider"></div>' +
        '<p class="ppt-message">' +
          'This website is not available in your region.' +
          '<br>' +
          '本网站在您所在的国家/地区不可访问。' +
        '</p>' +
      '</body>' +
      '</html>';

    document.documentElement.innerHTML = html;
  }

  /**
   * Try to detect the visitor's country from their IP.
   * Falls back through multiple APIs because no single free service
   * is 100% reliable or accessible from mainland China.
   *
   * @returns {Promise<string|null>} ISO country code or null if all APIs failed.
   */
  function detectCountry() {
    // Chain of APIs — each returns JSON, we extract the country code.
    // Order matters: most accessible-to-China APIs first.
    var apis = [
      // ip-api.com — free, no auth, supports CORS, accessible from CN
      {
        url: 'https://ip-api.com/json',
        extract: function(data) { return data && data.countryCode; }
      },
      // ip.userapi.eu — free, no auth, returns country_code
      {
        url: 'https://ip.userapi.eu/json/',
        extract: function(data) { return data && data.country_code; }
      },
      // ipinfo.io — free tier, returns country field
      {
        url: 'https://ipinfo.io/json',
        extract: function(data) { return data && data.country; }
      }
    ];

    function tryApi(index) {
      if (index >= apis.length) {
        console.warn('[region-block] All IP geolocation APIs failed.');
        return Promise.resolve(null);
      }

      var api = apis[index];
      return fetch(api.url, { mode: 'cors' })
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function(data) {
          var code = api.extract(data);
          if (code) {
            console.log('[region-block] Detected country:', code, '(via ' + api.url + ')');
            return code.toUpperCase();
          }
          throw new Error('No country code in response');
        })
        .catch(function(err) {
          console.warn('[region-block] ' + api.url + ' failed:', err.message);
          return tryApi(index + 1);
        });
    }

    return tryApi(0);
  }

  function checkAndBlock() {
    detectCountry().then(function(countryCode) {
      if (!countryCode) {
        // Detection failed — play safe and allow normal browsing
        return;
      }

      if (countryCode === 'CN') {
        renderBlockedPage();
      }
    });
  }

  // Run as early as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndBlock, { once: true });
  } else {
    checkAndBlock();
  }
})();
